export default __webpack_public_path__ + "static/blog_11-c15804d7a36e97745cd5cabfd10f6c1c.png";